module.exports = __webpack_public_path__ + "4313979875f8b5a3be0e730ab67a0358.png";